var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilterSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42949 1.179H7.57116V10.6019V10.6321L7.5925 10.6108L10.2669 7.93634L11.0661 8.74976L7.00033 12.8155L2.93467 8.74984L3.73368 7.95082L6.40818 10.6108L6.42949 10.632V10.6019V1.179Z",
    fill: "#0028B6",
    stroke: "#0028B6",
    strokeWidth: 0.025
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterSort);
export default __webpack_public_path__ + "static/media/icon_filter_sort.f900c29e064303c4e7b8108e2f6de978.svg";
export { ForwardRef as ReactComponent };